import React from 'react'

import { UnorderedList, ListItem, Button } from './styled'

import useOutsideClick from 'src/hooks/useOutsideClick'

interface Props {
  isOpen: boolean
  onClose: () => void
  openRemoveFriendModal: () => void
}

export const Dropdown: React.FC<Props> = ({
  isOpen,
  onClose,
  openRemoveFriendModal,
}) => {
  const ref = React.useRef<HTMLUListElement>(null)

  useOutsideClick({ ref, onOutsideClick: () => onClose() })

  return isOpen ? (
    <UnorderedList ref={ref}>
      <ListItem>
        <Button
          onClick={() => {
            openRemoveFriendModal()
            onClose()
          }}
        >
          Remove a friend
        </Button>
      </ListItem>
    </UnorderedList>
  ) : null
}
